var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessional(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E60012"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4167 29.25C29.4167 25.7982 32.215 23 35.6667 23H45.0417C48.4935 23 51.2917 25.7982 51.2917 29.25V31.3333H29.4167V29.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 40.7085L39.328 45.7905C39.6598 45.8735 40.0069 45.8735 40.3386 45.7905L60.6667 40.7085V54.2502C60.6667 55.4008 59.734 56.3335 58.5833 56.3335H21.0833C19.9327 56.3335 19 55.4008 19 54.2502V40.7085Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6667 42.7918V33.4168C60.6667 32.2662 59.734 31.3335 58.5833 31.3335H21.0833C19.9327 31.3335 19 32.2662 19 33.4168V42.7918",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4376 38.6252C42.4376 40.0634 41.2716 41.2293 39.8334 41.2293C38.3952 41.2293 37.2292 40.0634 37.2292 38.6252C37.2292 37.1869 38.3952 36.021 39.8334 36.021C41.2716 36.021 42.4376 37.1869 42.4376 38.6252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessional);
export default __webpack_public_path__ + "static/media/professional.5558b4454609585912c3077d178d03ba.svg";
export { ForwardRef as ReactComponent };